/**
 * Setup all Froms Designated to use Jquery Ajax
 * Handling by default
 */
$(document).ready(function () {
    setupJQueryForms();
    setupDirtySaveForms();
});

/**
 * Setup any Form with .ajaxForm class and
 * handle responses via Toastr
 */
function setupJQueryForms() {

    $('.ajaxForm').on('submit', function (e) {
        e.preventDefault(); // prevent native submit


        var form = $(this)

        // Ignore re-submits while a request is in flight (double click / double
        // fired submit would otherwise POST twice and duplicate server data).
        if (form.data('ajaxFormBusy')) {
            return;
        }
        form.data('ajaxFormBusy', true);
        var submitButtons = form.find('button[type="submit"], input[type="submit"]').prop('disabled', true);

        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            complete: function () {
                form.data('ajaxFormBusy', false);
                submitButtons.prop('disabled', false);

                // Runs after success(), so the baseline is already the saved
                // state here and a clean form goes straight back to disabled.
                if (form.is('[data-dirty-save]')) {
                    updateDirtySaveState(form);
                }
            },
            success: function (response, jsonResponse, jqXhr) {
                // data-notoast is for forms that render their own on-page success
                // message, so the toast would be a second copy of the same notice.
                if (response.notifytype && !form.is('[data-notoast]')) {
                    notify(response.notifytype, response.notifytitle, response.notifymessage);
                }

                if (form.data('showonsuccess')) {
                    $('#' + form.data('showonsuccess')).show();
                    $('#' + form.data('showonsuccess')).removeClass('d-none');
                }

                if (form.data('runfunctiononsuccess')) {
                    var successFunc = form.data('runfunctiononsuccess');
                    window[successFunc](response);
                }

                // What was just saved becomes the new "unchanged" state.
                if (form.is('[data-dirty-save]')) {
                    form.data('dirtySaveBaseline', form.serialize());
                }
            },
            error: function (jqXHR, status, error) {
                var allerrors = '';

                if (form.data('showonerror')) {
                    $('#' + form.data('showonerror')).show();
                    $('#' + form.data('showonerror')).removeClass('d-none');
                }

                /** IF this is a policy failure Alert the User **/
                if (jqXHR.responseJSON.message == 'Unauthenticated.') {
                    notify('error', 'Error!', 'You are not Authorized to take that Action!');
                    /** Otherwise show the Errors **/
                } else {
                    var errors = jqXHR.responseJSON.errors;
                    $.each(errors, function (key, value) {
                        allerrors = allerrors + value + '<br/>'
                    });
                    notify('error', 'Error!', allerrors);
                }
            }
        }, 'json');
    });
}

/**
 * Forms marked with data-dirty-save keep their submit button disabled until a
 * field actually changes, so the button only lights up when there is something
 * to save. Saving re-arms it against the newly stored values.
 */
function setupDirtySaveForms() {

    $('form[data-dirty-save]').each(function () {

        var form = $(this);

        form.data('dirtySaveBaseline', form.serialize());
        updateDirtySaveState(form);

        form.on('change input', ':input', function () {
            updateDirtySaveState(form);
        });
    });
}

/**
 * Enable/disable a dirty-save form's submit buttons by comparing the current
 * values against the baseline snapshot.
 */
function updateDirtySaveState(form) {

    var isDirty = form.serialize() !== form.data('dirtySaveBaseline');

    form.find('button[type="submit"], button:not([type]), input[type="submit"]')
        .prop('disabled', !isDirty)
        .toggleClass('is-dirty', isDirty);
}

